import React from "react";
import { Card, Form } from "react-bootstrap";
import { FORME_PAGAMENTO, OMAGGIO } from "./formePagamento";
import { numeroDaTesto, formattaPrezzo } from "../Util/prezzi";

// Le forme di pagamento si vedono tutte e si sceglie: niente menu a tendina e
// niente «già pagato», la scelta stessa dice che è pagato. L'omaggio è una delle
// scelte ma non è un incasso: chiude l'acquisto a zero, non genera documento
// fiscale e porta con sé il motivo.

const numero = (valore) => numeroDaTesto(valore);

/**
 * Riquadro «Prezzi e pagamento», uguale in tutte le vendite (abbonamenti, corsi,
 * impianti, lezioni): il prezzo modificabile, poi la forma di pagamento.
 *
 * - formData / setFormData: lo stato della pagina (prezzo_praticato, modalita_pagamento,
 *   is_pagato, is_omaggio, skip_generate_document, nota_omaggio)
 * - listino: il prezzo proposto dal sistema, per mostrarlo quando lo si cambia
 * - formRef: il form entra nel controllo dei campi obbligatori della pagina
 */
const PrezziPagamento = ({ formData, setFormData, listino, isFatturazioneConfirmed, formRef }) => {
    const prezzoCambiato = formData.prezzo_praticato !== ''
        && !isNaN(numero(listino))
        && numero(formData.prezzo_praticato) !== numero(listino);

    // L'omaggio è pagato come gli altri: l'acquisto si chiude subito (e fa scattare
    // socio, tessera, posto in squadra), solo che si chiude a zero e senza documento.
    // Il prezzo di prima si mette da parte: se l'operatore cambia idea lo ritrova.
    const scegli = (valore) => setFormData(prev => {
        const omaggio = valore === OMAGGIO;
        return {
            ...prev,
            modalita_pagamento: valore,
            is_omaggio: omaggio,
            is_pagato: true,
            prezzo_praticato: omaggio
                ? '0'
                : (prev.is_omaggio ? (prev.prezzo_prima_omaggio ?? '') : prev.prezzo_praticato),
            prezzo_prima_omaggio: omaggio && !prev.is_omaggio
                ? prev.prezzo_praticato
                : prev.prezzo_prima_omaggio,
            skip_generate_document: omaggio || !isFatturazioneConfirmed
                ? true
                : prev.skip_generate_document,
        };
    });

    return (
        <Card className="sid-pay">
            <Card.Header><h4 className="card-title">Prezzi e pagamento</h4></Card.Header>
            <Card.Body>
                <Form ref={formRef} noValidate>
                    <div className="sid-pay__prezzo">
                        <Form.Label htmlFor="prezzo_praticato">Prezzo</Form.Label>
                        <div className="sid-pay__importo">
                            <Form.Control
                                id="prezzo_praticato"
                                type="number"
                                min="0"
                                step="0.01"
                                name="prezzo_praticato"
                                disabled={formData.is_omaggio}
                                value={formData.prezzo_praticato}
                                onChange={(e) => setFormData(prev => ({ ...prev, prezzo_praticato: e.target.value }))}
                            />
                            <span className="sid-pay__valuta">€</span>
                        </div>
                        {prezzoCambiato && (
                            <div className="sid-pay__nota">Prezzo di listino: {formattaPrezzo(listino)}</div>
                        )}
                    </div>

                    <div className="sid-pay__metodi">
                        <div className="sid-radio-inline">
                            {FORME_PAGAMENTO.map(opzione => (
                                <Form.Check
                                    key={opzione.value}
                                    type="radio"
                                    name="modalita_pagamento"
                                    id={`pag-${opzione.value}`}
                                    label={opzione.label}
                                    checked={formData.modalita_pagamento === opzione.value}
                                    onChange={() => scegli(opzione.value)}
                                />
                            ))}
                        </div>
                        <div className="sid-pay__nota">
                            Se non indichi ora la forma di pagamento il sistema genera comunque l&apos;ordine: resta
                            da pagare e la forma di pagamento si registra in seguito, dalla scheda dell&apos;ordine.
                        </div>

                        {formData.is_pagato && !formData.is_omaggio && (
                            <div className="sid-switch-row sid-pay__extra">
                                <Form.Check
                                    type="switch"
                                    id="sw-documento"
                                    label="Genera il documento fiscale"
                                    disabled={!isFatturazioneConfirmed}
                                    checked={!formData.skip_generate_document}
                                    onChange={(e) => setFormData(prev => ({ ...prev, skip_generate_document: !e.target.checked }))}
                                />
                                {!isFatturazioneConfirmed && (
                                    <div className="sid-pay__nota">
                                        Non disponibile finché i dati di fatturazione della struttura non sono confermati in «La mia struttura».
                                    </div>
                                )}
                            </div>
                        )}

                        {formData.is_omaggio && (
                            <div className="sid-pay__extra sid-pay__omaggio">
                                <Form.Label htmlFor="nota_omaggio">Motivo dell&apos;omaggio</Form.Label>
                                <Form.Control
                                    id="nota_omaggio"
                                    as="textarea"
                                    rows={2}
                                    name="nota_omaggio"
                                    value={formData.nota_omaggio || ''}
                                    onChange={e => setFormData(prev => ({ ...prev, nota_omaggio: e.target.value }))}
                                />
                                <div className="sid-pay__nota">
                                    Per esempio «prova gratuita» o «convenzione»: resta sull&apos;acquisto, nella nota.
                                    L&apos;acquisto si chiude a zero e non genera documento fiscale.
                                </div>
                            </div>
                        )}
                    </div>
                </Form>
            </Card.Body>
        </Card>
    );
};

export default PrezziPagamento;
